import { loadForumPage, loadForumPost } from "./forum/forum.data";
import { loadWikiPage, wikiRedirect } from "./wiki/wiki.data";

type CommunityReadOptions = {
  data: { href: string };
  signal?: AbortSignal | undefined;
};

export function getForumPage({ data, signal }: CommunityReadOptions) {
  return loadForumPage({ ...data, signal });
}

export function getForumPost({ data, signal }: CommunityReadOptions) {
  return loadForumPost({ ...data, signal });
}

export function getWikiPage({ data, signal }: CommunityReadOptions) {
  return loadWikiPage({ ...data, signal });
}

export function getWikiRedirect({ data, signal }: CommunityReadOptions) {
  return wikiRedirect({ ...data, signal });
}
